import React from 'react';
import Link from 'next/link';
import { TwitterTimelineEmbed } from 'react-twitter-embed';

export const FeaturedPress = ({ article }) => {
    const showDate = new Date(article?.publishedAt).toLocaleDateString('en-gb', {
        year: 'numeric',
        month: 'short',
        // Day: 'numeric',
        timeZone: 'utc'
    });
    return (
        <div className='featpress'>
            <div className='featpress-content'>
                <Link href={article.articleUrl} legacyBehavior>
                    <div id='featpress-card'>
                        <img src='/assets/graphics/featured-badge.png' id='feat-badge' alt='Featured' />
                        <img
                            src='/assets/logos/billboard-logo.svg'
                            style={{ margin: '0 auto', display: 'block' }}
                        />
                        <span id='publish-date'>{showDate}</span>
                        <div id='featpress-img' />
                        <h2 style={{ color: '#121651' }}>{article?.title}</h2>
                        <p style={{ color: '#4f4f4f', fontSize: '18px' }}>
                            {article?.description}
                        </p>
                        <a id='read-more'>
                            Read Full Article <img src='/assets/icons/arrow-right.svg' />
                        </a>
                    </div>
                </Link>
                <div id='featured-press-social' className='ghost-inspector-hide'>
                    <TwitterTimelineEmbed
                        id='MuzologyEdu'
                        sourceType='profile'
                        screenName='MuzologyEdu'
                        options={{ height: 725, id: 'profile:MuzologyEdu' }}
                    />
                </div>
            </div>
            <style jsx>
                {`
                    #featpress-card {
                        transition: box-shadow 200ms ease;
                    }

                    #featpress-card:hover {
                        box-shadow: rgba(0, 0, 0, 0.15) 0px 8px 24px;
                    }

                    .featpress {
                        width: 100%;
                        background-color: #fff;
                        padding: 48px 60px;

                        .featpress-content {
                            max-width: 1100px;
                            margin: 0 auto;
                            display: grid;
                            grid-template-columns: 60% 40%;
                            grid-gap: 48px;

                            > div:first-child {
                                cursor: pointer;
                                padding: 32px;
                                position: relative;
                                background-color: #f3f3f3;
                                border-radius: 16px;
                                min-height: 240px;

                                #feat-badge {
                                    max-width: 140px;
                                    position: absolute;
                                    top: 16px;
                                    left: -8px;
                                }

                                #publish-date {
                                    position: absolute;
                                    top: 40px;
                                    right: 24px;
                                }

                                #featpress-img {
                                    margin: 24px 0;
                                    background-image: url("${article?.featuredImage?.url}");
                                    background-size: cover;
                                    background-repeat: no-repeat;
                                    background-position: top;
                                    min-height: 300px;
                                    border-radius: 16px;
                                }

                                #read-more {
                                    cursor: pointer;
                                    font-weight: 800;
                                    font-size: 24px;
                                    line-height: 28px;
                                    background: -webkit-linear-gradient(135deg,
                                    #e637a8 2.69%,
                                    #e68137 75%);
                                    -webkit-background-clip: text;
                                    -webkit-text-fill-color: transparent;
                                    text-decoration-line: underline;
                                    display: flex;
                                    margin-top: 40px;

                                    img {
                                        width: 35px;
                                        height: auto;
                                        margin-left: 6px;
                                        transition: margin-left 150ms ease;
                                    }
                                }

                                #read-more:hover {
                                    img {
                                        margin-left: 18px;
                                    }
                                }
                            }

                            > div:nth-child(2) {
                                border: 2px solid #ccc;
                                border-radius: 16px;
                                padding: 8px;
                                max-width: 400px;
                            }
                        }
                    }

                    @media (max-width: 1100px) {
                        .featpress {
                            .featpress-content {
                                display: block;

                                > div:nth-child(2) {
                                    display: none;
                                }
                            }
                        }
                    }

                    @media (max-width: 992px) {
                        .featpress {
                            padding: 48px 40px;

                            #feat-badge,
                            #publish-date {
                                display: none !important;
                            }
                        }
                    }

                    @media (max-width: 480px) {
                        .featpress {
                            padding: 48px 20px;

                            .featpress-content {
                                > div {
                                }

                                #read-more {
                                    -webkit-text-fill-color: inherit !important;
                                    background: #f3f3f3;
                                    color: #e68137;
                                }
                            }
                        }
                    }
                `}
            </style>
        </div>
    );
};
